import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const qk = (project: string) => ["construction", "board", project] as const;

export const useConstructionBoard = (project: string | undefined) =>
  useQuery({
    queryKey: qk(project ?? ""),
    queryFn: () => api.getBoard(project!),
    enabled: Boolean(project),
  });

export const useSeedStages = (project: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.seedStages(project),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk(project) }),
  });
};

export const usePatchStage = (project: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof api.patchStage>[1] }) =>
      api.patchStage(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk(project) }),
  });
};

export const useAddStage = (project: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Omit<Parameters<typeof api.addStage>[0], "project">) =>
      api.addStage({ project, ...data }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk(project) }),
  });
};

export const useDeleteStage = (project: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.deleteStage(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk(project) }),
  });
};
